import _ from 'lodash';
import dynamic from 'next/dynamic';
import SecFullHEnergy from './sec-full-h-live-energy';
// import SecFullH from 'src/components/sections/section-video/sec-full-h-live';

const SecFullH = dynamic(import('src/components/sections/section-video/sec-full-h-live'));

const SectionLive = ({ data, secEnergy = false, eventDataLayer }) => {
  return (
    <>
      {secEnergy ? (
        <>
          {!_.isEmpty(data) && (
            <div className='container mb-4'>
              <SecFullHEnergy
                data={data}
                //! DATALAYER
                eventDataLayer={{ ...eventDataLayer }}
              />
            </div>
          )}
        </>
      ) : (
        <>
          {!_.isEmpty(data) && (
            <div className='container mb-4'>
              <SecFullH
                data={data}
                //! DATALAYER
                eventDataLayer={{ ...eventDataLayer }}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SectionLive;
